const win = window;
{
  win.o_global ||= {};
  win.o_util ||= {};
}
const { o_global, o_util } = win;
const otto = win.otto ?? {};
const components = otto.components;
export {
  o_global as a,
  components as c,
  o_util as o,
  win as w
};
/*                                                  */
